export default {
  'Screenshot': 'Captura de pantalla',
}